import { api } from './index';

const AdminRequestService = {
    getCompaniesList(params){
        return api.get('admin/get-companies-list',params);
    },
    getBlockedCompanies(params){
        return api.get('admin/get-blocked-companies',params);
    },
    changeBlockSistem(formData){
        return api.post('admin/change-block-sistem',formData);
    },
    getActionBlockedCompanies(params){
        return api.get('admin/get-action-blocked-companies',params);
    },
    changeBlockAction(formData){
        return api.post('admin/change-block-action',formData);
    },
    getMessageActionBlockedCompanies(){
        return api.get('admin/get-message-action-blocked-companies');
    },
    setMessageActionBlockedCompanies(message){
        let formData = new FormData();
        formData.append("message",message);
        return api.post('admin/set-message-action-blocked-companies',formData);
    },
    setConfig(key, value){
        let formData = new FormData();
        formData.append("key",key);
        formData.append("value",value);
        return api.post('admin/config/set',formData);
    },
    getConfig(key){
        return api.get('admin/config/get',{params:{key}});
    },
    verifyActionBlockedCompanies(company_id){
        return api.get('admin/verify/action-blocked-companies',{params:{company_id}});
    },
    verifyAddMoreAction(company_id){
        return api.get('admin/verify/add-more-action',{params:{company_id}});
    },
    getUsersBlock(company_id){
        return api.get('admin/get-users-block',{params:{company_id}});
    },
    //get-users-block
};

export default AdminRequestService;